export const baseInputStrings = {
    EMAIL: "Email",
    FIRST_NAME: "First Name",
    LAST_NAME: "Last Name",
    VALIDATION_CODE: "Validation Code"
};
